import { AccessPointCheckIcon } from './AccessPointCheckIcon';

/**
 * author: Colton Wiscombe
 * id 45F0D360-E817-4152-A66E-EF019E10ED47
 * name access-point-check
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/access-point-check.svg
 * tags
 */
export const AccessPointSuccessIcon = AccessPointCheckIcon;
export default AccessPointSuccessIcon